import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../core/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/observable/throw';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {UserService} from '../../services/user.service';
import {
  ActivePages,
  EventTrackerService,
  Page,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {CommonConstant, FacebookAuthSource} from '../../app.constants';
import {FbTestingPageComponent} from '../../fb-testing-page/fb-testing-page.component';
import {environment} from '../../../environments/environment';
import {AppSettings} from '../../utils/app-settings';
import {FbAuthorisationError} from '../../fb-testing-page/fb-login-fail/fb-login-fail.component';

@Component({
  selector: 'app-influencer-login',
  templateUrl: './influencer-login.component.html',
  styleUrls: ['./influencer-login.component.scss']
})

export class InfluencerLoginComponent implements OnInit {

  user: FormGroup;
  errorCode: string;
  isLoggedInWithAdvertiserAccount: boolean;
  private facebookAuthUrl: string;
  private env = environment;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private placeholderService: PlaceholderVisibilityService,
    private userService: UserService,
    private eventTracker: EventTrackerService) {}

  ngOnInit() {
    this.user = new FormGroup({
      username: new FormControl(null, [
        Validators.required,
        Validators.email
      ]),
      password: new FormControl(null, [
        Validators.required
      ])
    });
    const facebookAppId = this.env.facebookAppId;
    const fbRedirectUri = this.env.fbRedirectUri;
    const fbAppState = `${this.env.fbAppState};source=${FacebookAuthSource.ORGANIC_LOGIN}`;
    const scopes = AppSettings.facebookAuthScopes();
    this.facebookAuthUrl = `${FbTestingPageComponent.FB_GRAPH_API}/dialog/oauth?client_id=${facebookAppId}&redirect_uri=${fbRedirectUri}&state=${fbAppState}&response_type=code&scope=${scopes}`;
    this.handleAuthorizeFail();
  }

  onSubmit({ value, valid }: {value: any, valid: boolean}) {
    if (valid) {
      this.isLoggedInWithAdvertiserAccount = false;
      this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
      this.auth.login(value.username, value.password, data => {
        this.loadUserData();
      }, error => {
        this.handleLoginError(error);
        this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
      });
    }

    return false;
  }

  signInWithFacebook() {
    window.location.href = this.facebookAuthUrl;
  }

  get hasNoBusinessAccountError() {
    return this.errorCode && this.errorCode === FbAuthorisationError.NO_BUSINESS_USER;
  }

  get hasMissingPermissionError() {
    return this.errorCode && this.errorCode === FbAuthorisationError.MISSING_PERMISSION;
  }

  get hasFacebookGeneralPermissionError() {
    return this.errorCode && (this.errorCode === FbAuthorisationError.PAGE_SUBSCRIPTION_FAILED
      || this.errorCode === FbAuthorisationError.FACEBOOK_ERROR);
  }

  get hasErrorSelectUser() {
    return this.errorCode && this.errorCode === FbAuthorisationError.ERROR_SELECT_USER;
  }

  get hasError() {
    return this.errorCode;
  }

  get hasFbAuthError() {
    return this.errorCode && (this.errorCode === FbAuthorisationError.MISSING_CODE
      || this.errorCode === FbAuthorisationError.INVALID_INFLUENCER
      || this.errorCode === FbAuthorisationError.UNABLE_TO_COLLECT_BACKWARD
      || this.errorCode === FbAuthorisationError.INVALID_TOKEN);
  }

  private handleAuthorizeFail() {
    this.route.queryParams.subscribe((res) => {
      if (res.error) {
        this.errorCode = res.error;
      }
    });
  }

  private loadUserData() {
    this.auth.getUserData(user => {
      if (user.data.company.influencer !== true) {
        this.auth.resetUserData();
        this.isLoggedInWithAdvertiserAccount = true;
        this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
        return;
      }
      if (!this.userService.getCompanyId()) {
        this.userService.setCurrentCompanyForInfluencer(this.auth.getUser().companyId);
      }
      this.eventTracker.hasIdentifiedObserver.subscribe((res) => {
        if (res) {
          this.eventTracker.trackUserAction(UserActionType.LOGIN, Page.LOGIN, undefined, undefined, undefined, {
            type: ActivePages.LOGIN,
          });
        }
      });
      this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
      const redirectUrl = this.getRedirectUrl();
      if (redirectUrl) {
        this.router.navigateByUrl(redirectUrl);
      } else if (AppSettings.isDisableHomepage()) {
        this.router.navigate(['dashboard', 'details']);
      } else {
        this.router.navigate(['dashboard', 'home']);
      }
    }, err => {
      this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
      this.errorCode = err.error.message;
      this.auth.logout();
    });
  }

  private handleLoginError(error) {
    if (error.error.data === 'invalid_credential') {
      this.errorCode = error.error.message;
    } else if (error.status === 400) {
      this.errorCode = this.translate.instant('LOGIN.wrong_username_password');
    } else {
      this.errorCode = error.error.message;
    }
  }

  private getRedirectUrl() {
    let returnUrl = null;
    if (this.route.snapshot.queryParams['target_url']) {
      returnUrl = decodeURIComponent(this.route.snapshot.queryParams['target_url']);
    }
    return returnUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-login/influencer-login.component.ts